import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { employeeDirectoryService } from '../../api/services/employeeDirectoryService';
import { setLoading } from '../../infra/aggregates/LoaderSlice';
import { useAppDispatch, useAppSelector } from '../../infra/hooks';
interface PropsValues {
  setEmpDirectory: (data: any) => void;
  setAllDepartments: (data2: any) => void;
  setPageDetails: (data3: any) => void;
  setTotalEmpDirectory: (total: any) => void;
  pageNumber: any;
  rowPerPage?: any;
  page?: any;
  filterDept?:any
  search?:any
}

function DTOEmpDirectory({
  setEmpDirectory,
  setTotalEmpDirectory,
  setAllDepartments,
  setPageDetails,
  pageNumber,
  rowPerPage,
  page,
  filterDept,
  search
}: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();
  const companyId = useAppSelector((state) => state.authSlice.company_id);
  const full_path = '';
  const getAccess = useAppSelector((state) => state.roleInfo.viewAccess);

  async function getEmployeeDirectory(companyId: number, full_path: string) {
    dispatch(setLoading(true));
    try {
      const response: any = await employeeDirectoryService.getallEmpData(
        companyId,
        full_path,
        rowPerPage,
        page + 1,
        getAccess,
        filterDept,
        search
      );

      if (response.response == 'success') {
        dispatch(setLoading(false));
        setTotalEmpDirectory(response?.data?.data?.length);
        const empDirectory: any = response?.data?.data;
        const PageDetails: any = response?.data;
        //   dispatch(setEmployeeActiveDocs(empDocsData));
        /* Passing Props to Controller */
        setPageDetails(PageDetails)
        setEmpDirectory(empDirectory);
      } else {
        dispatch(setLoading(false));
        return;
      }
    } catch (err) {
      return err;
    }
  }
  useEffect(()=>{
    getEmployeeDirectory(companyId,full_path)
  },[page,rowPerPage,filterDept,search])

  async function getAllDepartments() {
    const response =
      await employeeDirectoryService.getDepartmentList(companyId);
    if (response) {
      const { data }: any = response;
      setAllDepartments(data);
    }
  }

  useEffect(() => {
    getAllDepartments();
    if (selector.company_id)
      getEmployeeDirectory(selector.company_id, full_path);
  }, []);

  async function getEmployeeDirectoryByPage(
    pageNumber: any,
    companyId: number,
    full_path: string,
  ) {
    const response: any = await employeeDirectoryService.getallEmpData(
      companyId,
      full_path,
    );

    if (response.response == 'success') {
      // const empDirectory: any = response?.data.slice(
      //   pageNumber?._from,
      //   pageNumber?._to
      // );

      setEmpDirectory(response?.data);
    } else {
      return;
    }
  }
  useEffect(() => {
    getAllDepartments();
    if (pageNumber._from || pageNumber._to)
      getEmployeeDirectoryByPage(pageNumber, selector.company_id, full_path);
  }, [pageNumber]);

  return <></>;
}

export default DTOEmpDirectory;
